import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import {TextField} from '@mui/material';
import styled from 'styled-components';
import Autocomplete from '@mui/material/Autocomplete';

const ButtonWrapper = styled.div`
  display: flex;
`;

const PartNoEdit = ({
  k,row, editFormData, handleCancelClick,
  consumcat, consummaster, brandmaster,
  page, rowsPerPage, onChangeEditPartNumber,
  SubmitButton, modelnumber,selectedConsum,
  getAssetModelOptions,setEditFormData
}) => {    
    return( <>
    <TableRow key={k} name={row.Category}>
      <TableCell component="th" scope="row">
        {(page)*(rowsPerPage)+k+1}
      </TableCell>
      
      <TableCell  align="left">
        <TextField
          id="outlined-basic"
          size='small'
          type="text"
          name= "partno"
          onChange={(event, newValue) => onChangeEditPartNumber(event, newValue)}
          label="Part Number"
          value={editFormData.partno}
          variant="outlined"
          sx={{backgroundColor:"white", minWidth:"150px",  height:"40px"}}
        />         
    </TableCell>

    <TableCell  align="left">
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        size='small'
        value={editFormData?.consumcategory}
        onChange={(event, newValue) => onChangeEditPartNumber(event, newValue, "consumcategory" , row.id)}
        options={ Object.values(consumcat)?.map(x => x.name)}
        sx={{backgroundColor:"white", minWidth:"200px",   marginRight:"20px",height:"40px"}}
        renderInput={(params) => <TextField {...params} label={"Select Consumable Category"} />}
      />
    </TableCell>

    <TableCell  align="left">
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        size='small'
        value={editFormData?.consumable}
        onChange={(event, newValue) => onChangeEditPartNumber(event, newValue, "consumable" )}
        options={consummaster? Object.values(consummaster).filter( a => a?.consumcategory === editFormData?.consumcategory ).map(x => x.consumable):[]}
        sx={{backgroundColor:"white", minWidth:"150px",  marginRight:"20px",height:"40px"}}
        renderInput={(params) => <TextField {...params} label={"Select Consumable"} />}
      />
    </TableCell>

    <TableCell  align="left">
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        size='small'
        value={editFormData?.brand}
        onChange={(event, newValue) => onChangeEditPartNumber(event, newValue, "brand" )}
        options={(brandmaster && editFormData?.consumcategory?.length)? Object.values(brandmaster).map(x => x.name):[]}
        sx={{backgroundColor:"white", minWidth:"150px",  marginRight:"20px",height:"40px"}}
        renderInput={(params) => <TextField {...params} label={"Select Brand"} />}
      />
    </TableCell>

    <TableCell  align="left">
      <Autocomplete
        multiple
        id="combo-box-demo"
        size='small'
        options={getAssetModelOptions({
          modelnumber,
          addPartNumber: editFormData,
          selectedConsum,
          setAddPartNumber: setEditFormData
        })}
        sx={{backgroundColor:"white", minWidth:"320px",height:"40px"}}
        value={editFormData.assetModelNos}
        onChange={(event, newValue) =>onChangeEditPartNumber(event, newValue, "assetModelNos")}
        renderInput={(params) => ( 
          <TextField
            {...params}
            variant="outlined"
            label="Select Asset Model Nos"
            // placeholder="Asset Model Nos"
          />
        )}
      />
    </TableCell>         

    <TableCell align="left">
      <ButtonWrapper>
        <SubmitButton type="submit">Save</SubmitButton>
        <SubmitButton type="button" onClick={(e)=>handleCancelClick(e,k)}>Cancel</SubmitButton>
      </ButtonWrapper>                              
      </TableCell>
    </TableRow>     
    </>         
  )
}

export default PartNoEdit;